var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerServiceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer Service"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 60.1172V40.1172C10 32.1607 13.1607 24.5301 18.7868 18.904C24.4129 13.2779 32.0435 10.1172 40 10.1172C47.9565 10.1172 55.5871 13.2779 61.2132 18.904C66.8393 24.5301 70 32.1607 70 40.1172V60.1172",
    stroke: "url(#paint0_linear_1219_29509)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M70 63.4508C70 65.219 69.2976 66.9146 68.0474 68.1649C66.7971 69.4151 65.1014 70.1175 63.3333 70.1175H60C58.2319 70.1175 56.5362 69.4151 55.286 68.1649C54.0357 66.9146 53.3333 65.219 53.3333 63.4508V53.4508C53.3333 51.6827 54.0357 49.987 55.286 48.7368C56.5362 47.4866 58.2319 46.7842 60 46.7842H70V63.4508ZM10 63.4508C10 65.219 10.7024 66.9146 11.9526 68.1649C13.2029 69.4151 14.8986 70.1175 16.6667 70.1175H20C21.7681 70.1175 23.4638 69.4151 24.714 68.1649C25.9643 66.9146 26.6667 65.219 26.6667 63.4508V53.4508C26.6667 51.6827 25.9643 49.987 24.714 48.7368C23.4638 47.4866 21.7681 46.7842 20 46.7842H10V63.4508Z",
    stroke: "url(#paint1_linear_1219_29509)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1219_29509",
    x1: 10,
    y1: 35.4336,
    x2: 70,
    y2: 35.4336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1219_29509",
    x1: 10,
    y1: 58.5985,
    x2: 70,
    y2: 58.5985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#003DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46DB8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerServiceActive);
export default __webpack_public_path__ + "static/media/customer-service-active.4fba67a9431895ae1b3a13a5cf59bd50.svg";
export { ForwardRef as ReactComponent };